import React from 'react'

import { Link, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { DATE_FORMATS_LUXON, formatISOFromUTC } from '@/utils/dateHelpers'

import { REPORT_DISCLAIMER } from '../lib/disclaimer'

const DISCLAIMER_HEADING_ID = 'report-disclaimer-heading'

/** The one line that has to be above the fold: fine print at the bottom of the
 *  page is functionally the same as none for a report a reader might act on. */
export const ReportDisclaimerLead: React.FC = () => (
  <Text variant={TypographyStyles.BODY_XS} color={TextColors.MUTED}>
    {REPORT_DISCLAIMER.lead}
  </Text>
)

/**
 * Passive notice, deliberately: no modal, checkbox, or acknowledgement. Proof of
 * acceptance is a different mechanism and would need an explicit action plus a
 * persisted record of `REPORT_DISCLAIMER.version` and a timestamp.
 *
 * `generatedAt` is the API's date-only `YYYY-MM-DD`, formatted in UTC so the
 * date a reader sees is the one the report's statuses were computed against.
 */
export const ReportDisclaimerFooter: React.FC<{ generatedAt: string }> = ({
  generatedAt,
}) => (
  <section
    aria-labelledby={DISCLAIMER_HEADING_ID}
    className="mt-10 flex flex-col gap-2 border-t border-neutral-100 pt-5"
  >
    {/* A real heading element, not the `Text` atom: `Text` always renders a
        `<p>`, which cannot name a section for a screen reader. */}
    <h2 id={DISCLAIMER_HEADING_ID} className="label-xs text-neutral-900">
      About this report
    </h2>
    {[
      REPORT_DISCLAIMER.asOf(
        formatISOFromUTC(generatedAt, DATE_FORMATS_LUXON.DISPLAY_LONG_SHORT_DAY)
      ),
      ...REPORT_DISCLAIMER.details,
    ].map((paragraph) => (
      <Text
        key={paragraph}
        variant={TypographyStyles.BODY_XS}
        color={TextColors.MUTED}
      >
        {paragraph}
      </Text>
    ))}
    <Link
      newPage
      href={REPORT_DISCLAIMER.termsOfServiceUrl}
      className="text-xs"
    >
      See Heard&apos;s Terms of Service
    </Link>
  </section>
)
